import { Fragment } from 'react';
import { string, func } from 'prop-types';

import StyledMenu from './StyledMenu';
import SideMenu from '../SideMenu';
import { withI18next } from '../../lib/withI18next';
import getCurrentLang from '../../lib/getCurrentLang';

const Menu = ({ i18n, t, pathname, fontColor, updateI18lCategoryList }) => {
  const toggle = value => {
    updateI18lCategoryList && updateI18lCategoryList();
    window.location = `/?lng=${value}`;
  };
  const selectedLang = getCurrentLang(i18n);

  const options = [{ value: 'cs', label: 'CS' }, { value: 'en', label: 'EN' }];

  return (
    <Fragment>
      <SideMenu
        pathname={pathname}
        fontColor={fontColor}
        options={options}
        toggle={toggle}
        selectedLang={selectedLang}
      />
      <StyledMenu
        pathname={pathname}
        fontColor={fontColor}
        options={options}
        toggle={toggle}
        selectedLang={selectedLang}
      />
    </Fragment>
  );
};

Menu.propTypes = {
  pathname: string.isRequired,
  fontColor: string.isRequired,
  updateI18lCategoryList: func,
};

export default withI18next()(Menu);



// WEBPACK FOOTER //
// components/Menu/index.js